export const canonicalChannelIds = [
  'channel-1',
  'channel-4',
  'channel-5',
  'channel-6',
  'channel-8',
  'channel-74',
  'channel-76',
  'channel-78',
  'channel-82',
  'channel-83',
  'channel-84',
  'channel-88',
]

export default {
  '16618B7F7AC551F48C057A13F4CA5503693FBFF507719A85BC6876B8BD75F821': {
    path: 'transfer/channel-83',
    baseDenom: 'aevmos',
  },
  '0954e1c28eb7af5b72d24f3bc2b47bbb2fdf91bddfd57b74b99e133aed40972a': {
    path: 'transfer/channel-88',
    baseDenom: 'uscrt',
  },
  '646315E3B0461F5FA4C5C8968A88FC45D4D5D04A45B98F1B8294DD82F386DD85': {
    path: 'transfer/channel-6',
    baseDenom: 'uosmo',
  },
  '92E0120F15D037353CFB73C14651FC8930ADC05B93100FD7754D3A689E53B333': {
    path: 'transfer/channel-8',
    baseDenom: 'uosmo',
  },
  B786E7CBBF026F6F15A8DA248E0F18C62A0F7A70CB2DABD9239398C8B5150ABB: {
    path: 'transfer/channel-82',
    baseDenom: 'uxprt',
  },
  B448C0CA358B958301D328CCDC5D5AD642FC30A6D3AE106FF721DB315F3DDE5C: {
    path: 'transfer/channel-4',
    baseDenom: 'uusd',
  },
  B8AF5D92165F35AB31F3FC7C7B444B9D240760FA5D406C49D24862BD0284E395: {
    path: 'transfer/channel-4',
    baseDenom: 'uluna',
  },
  C49B72C4E85AE5361C3E0F0587B24F509CB16ECEB8970B6F917D697036AF49BE: {
    path: 'transfer/channel-77',
    baseDenom: 'uaxl',
  },
  B68C1D2682A8B69E20BB921E34C6A3A2B6D1E13E3E8C0092E373826F546DEE65: {
    path: 'transfer/channel-84',
    baseDenom: 'uaxl',
  },
  C4CFF46FD6DE35CA4CF4CE031E643C8FDC9BA4B99AE598E9B0ED98FE3A2319F9: {
    path: 'transfer/channel-1',
    baseDenom: 'uatom',
  },
  D24B4564BCD51D3D02D9987D92571EAC5915676A9BD6D9B0C1D0254CB8A5EA34: {
    path: 'transfer/channel-5',
    baseDenom: 'uosmo',
  },
  D50E26996253EBAA8C684B9CD653FE2F7665D7BDDCA3D48D5E1378CF6334F211: {
    path: 'transfer/channel-78',
    baseDenom: 'ujuno',
  },
  E7807A46C0B7B44B350DA58F51F278881B863EC4DCA94635DAB39E52C30766CB: {
    path: 'transfer/channel-76',
    baseDenom: 'uhuahua',
  },
}
